export function toJSON() {
  return {
    artist: '',
    created: null,
    keywords: [],
    name: '',
    popularity: 0,
    printable: false,
    rating: null,
    retired: false,
    type: '',
    updated: null,
    uyo: false,
    visible: null,
    assets: {
      customCss: '',
      thumbEmail: '',
      thumbSlider: '',
      backgroundImage: '',
      mobileImage: '',
      thumbMobile: '',
      thumb3ColumnGrid: '',
      thumbSmallGallery: '',
    },
    categories: [],
    css: '',
    customFonts: [],
    displayName: '',
    designType: 0,
    designTypeName: '',
    eventType: '',
    altTag: '',
    aspectRatio: null,
    attributionAuthor: '',
    attributionColor: '',
    cardGender: '',
    currentVersionId: null,
    eventTitleColor: '',
    imageType: null,
    informationColor: '',
    publishedDate: null,
    uploadImages: null,
    versionName: null,
    wordingType: null,
    flash: null,
    attribution: {
      color: null,
      author: null,
    },
  };
}

export default {toJSON};
